"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var localized_strings_1 = require("localized-strings");
exports.massAndWeightUnits = new localized_strings_1.default({
    en: {
        CentrumPound: {
            AbbreviatedDisplay: 'cwt',
            FullDisplay: 'cwt'
        },
        Gram: {
            AbbreviatedDisplay: 'g',
            FullDisplay: 'grams'
        },
        Kilogram: {
            AbbreviatedDisplay: 'kg',
            FullDisplay: 'kilograms'
        },
        LongTon: {
            AbbreviatedDisplay: 'long ton',
            FullDisplay: 'long tons'
        },
        MetricTon: {
            AbbreviatedDisplay: 'm ton',
            FullDisplay: 'metric tons'
        },
        Milligram: {
            AbbreviatedDisplay: 'mg',
            FullDisplay: 'milligram'
        },
        Ounce: {
            AbbreviatedDisplay: 'oz',
            FullDisplay: 'ounces'
        },
        Pound: {
            AbbreviatedDisplay: 'lb',
            FullDisplay: 'pounds'
        },
        ShortTon: {
            AbbreviatedDisplay: 'short ton',
            FullDisplay: 'short tons'
        }
    },
    es: {
        Gram: {
            AbbreviatedDisplay: 'g',
            FullDisplay: 'gramos'
        },
        Kilogram: {
            AbbreviatedDisplay: 'kg',
            FullDisplay: 'kilogramos'
        },
        LongTon: {
            AbbreviatedDisplay: 't larga USA',
            FullDisplay: 'toneladas largas USA'
        },
        MetricTon: {
            AbbreviatedDisplay: 't',
            FullDisplay: 'toneladas'
        },
        Milligram: {
            AbbreviatedDisplay: 'mg',
            FullDisplay: 'milligramos'
        },
        Ounce: {
            AbbreviatedDisplay: 'oz',
            FullDisplay: 'onzas'
        },
        Pound: {
            AbbreviatedDisplay: 'lb',
            FullDisplay: 'libras'
        },
        ShortTon: {
            AbbreviatedDisplay: 't corta USA',
            FullDisplay: 'toneladas cortas USA'
        }
    }
}, {
    logsEnabled: false
});
